import { format } from '@if/core/date'
import { formatCurrency } from '@if/core/utils'
import { DocumentField, Placeholder, SummaryCard } from '@if/mui'
import { Stack } from '@mui/material'
import { PaymentMethodIconComponent } from '@src/components/LoanCalendar/PaymentMethodIconComponent'
import { CustomerPaymentOperation } from '@src/types/loan/loan-operation'
import { CalendarClock } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface Props {
  threeNextPayments: CustomerPaymentOperation[]
}

const LoanNextPaymentCard = ({ threeNextPayments }: Props) => {
  const { t } = useTranslation()

  return (
    <SummaryCard icon={CalendarClock} title={t('loan.payment.nextPaymentCard.title')} dense>
      {threeNextPayments.length === 0 && <Placeholder>{t('loan.payment.nextPaymentCard.empty')}</Placeholder>}
      {threeNextPayments.map((payment) => (
        <DocumentField
          key={payment.id}
          label={format(payment.effectiveDate, 'P')}
          align="right"
          value={
            <Stack component="span" direction="row" spacing={1} alignItems="center">
              <span>{formatCurrency(payment.amount)}</span>
              <PaymentMethodIconComponent paymentMode={payment.paymentMethodId} />
            </Stack>
          }
          strong
        />
      ))}
    </SummaryCard>
  )
}

export default LoanNextPaymentCard
